export default {
  message: {
    hello: 'hola mundo'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es.js